import { Component, Input, Output, OnInit, OnDestroy, EventEmitter, Inject } from '@angular/core';
import { MapService } from '@app/map/services/map.service';
import { AuthService } from '@app/common/services/auth.service';
import { APP_BRAND, APP_CONFIG } from '@app/common/services/config.service';
import { Restangular } from 'ngx-restangular';
import * as  L from 'leaflet';
import { VfkParserService } from '@app/map/services/vfk-parser.service';

@Component({
  selector: 'map-module-gp-vfk',
  templateUrl: './map-module-gp-vfk.component.html',
  styleUrls: ['./map-module-gp-vfk.component.scss']
})
export class MapModuleGpVfkComponent implements OnInit {

  @Input() title: string;
  @Input() mapId: string;
  @Input() config: any;
  @Output() visibilityInfoboxCallback =  new EventEmitter();

  open = true;
  map;
  vfk;
  canShowMap = false;
  fitBounds = true;

  groups = [
    { id: 'HP', title: 'Nové hranice parcel', enabled: true, type: 'parcel' },
    { id: 'OP', title: 'Čísla parcel', enabled: true, type: 'parcel' },
    { id: 'ZVB', title: 'Věcné břemeno', enabled: true, type: 'vb' },
  ];

  private jsonSrc: any = {};
  private layers = {};

  private layersSrc;

  private readonly LAYERS_CONFIG_PARCEL = [
    // Hranice
    {
      id: 'HPA',
      title: 'Hranice parcel - aktuální',
      group: 'HP',
      style: { fillOpacity: 0, color: '#ff0000', weight: 1, dashArray: '5 5' },
      filter: (f) => {
        return f.geometry && (
          (f.properties.PRIZNAK_KONTEXTU === undefined && f.properties.STAV_DAT === 0)
          || (f.properties.PRIZNAK_KONTEXTU === 1 && f.properties.STAV_DAT === 0));
      },
      data: undefined,
    },
    {
      id: 'HPFA',
      title: 'Hranice parcel - budoucí ponechané',
      group: 'HP',
      style: { fillOpacity: 0, color: '#000000', weight: 2 },
      filter: (f) => {
        return true;
      },
      customMapper: (f) => this.customMapperPonechane(f),
      data: undefined,
    },
    {
      id: 'HPFN',
      title: 'Hranice parcel - budoucí nové',
      group: 'HP',
      style: { fillOpacity: 0, color: '#ff4D00', weight: 3 },
      filter: (f) => {
        return true;
      },
      customMapper: (f) => this.customMapperNove(f),
      data: undefined,
    },

    // Body
    {
      id: 'OPF',
      title: 'Obrazy parcel',
      group: 'OP',
      style: { fillOpacity: 0, color: '#000000', weight: 2 },
      filter: (f) => {
        return f.geometry
          && (f.properties.TEXT && (f.properties.OPAR_TYPE === 'PC' || f.properties.OPAR_TYPE === 'PPC') && f.properties.VELIKOST > 0.1)
          && (
            (f.properties.PRIZNAK_KONTEXTU === undefined && f.properties.STAV_DAT === 2)
            || (f.properties.PRIZNAK_KONTEXTU === 3 && f.properties.STAV_DAT === 1)
          );
      },
      pointToLayer: (a, b) => this.pointToLayerOP(a, b),
      data: undefined,
    },
    {
      id: 'OPFA',
      title: 'Obrazy parcel - šipky',
      group: 'OP',
      style: { fillOpacity: 0, color: '#FF0000', weight: 1 },
      filter: (f) => {
        return f.geometry
          && (f.properties.TEXT && (f.properties.OPAR_TYPE === 'PC' || f.properties.OPAR_TYPE === 'PPC'))
          && (
            (f.properties.PRIZNAK_KONTEXTU === undefined && f.properties.STAV_DAT === 2)
            || (f.properties.PRIZNAK_KONTEXTU === 3 && f.properties.STAV_DAT === 1)
          );
      },
      customMapper: this.customMapperArrows,
      data: undefined,
    },
  ];

  private readonly LAYERS_CONFIG_VB = [
    // Hranice
    {
      id: 'VB',
      title: 'Věcné břemeno',
      group: 'ZVB',
      style: { fillOpacity: 0, color: '#0032c8', weight: 2 },
      filter: (f) => {
        return f.geometry && (
          (f.properties.PRIZNAK_KONTEXTU === undefined && f.properties.STAV_DAT === 2)
          || (f.properties.PRIZNAK_KONTEXTU === 3 && f.properties.STAV_DAT === 1));
      },
      data: undefined,
    }
  ];

  constructor(
    private mapService: MapService,
    private authService: AuthService,
    private restangular: Restangular,
    private vfkParser: VfkParserService,
    @Inject(APP_BRAND) private APP_BRAND: any,
    @Inject(APP_CONFIG) private appConfig: any,
  ) {
    this.show = this.show.bind(this);
    this.pointToLayerOP = this.pointToLayerOP.bind(this);
    this.isSegmentOnSegment = this.isSegmentOnSegment.bind(this);
    this.customMapperNove = this.customMapperNove.bind(this);
    this.customMapperPonechane = this.customMapperPonechane.bind(this);
  }

  async ngOnInit() {
    this.visibilityInfoboxCallback.emit({ infoboxVisibility: true });
    this.map = await this.mapService.getMap(this.mapId);
    this.layers[this.mapId] = [];


    await this.loadVfkFile();
    const text = await this.vfk.text();
    const vfkType = this.vfkParser.getVfkType(text);
    this.layersSrc = vfkType === 'parcel' ? this.LAYERS_CONFIG_PARCEL : this.LAYERS_CONFIG_VB;
    this.groups = this.groups.filter(g => g.type === vfkType);
    const vfkJson = this.vfkParser.vfkToJson(text);
    this.jsonSrc.ZVB = this.vfkParser.buildGeoJsonLayer('ZVB', vfkJson);
    this.jsonSrc.HP = this.vfkParser.buildGeoJsonLayer('HP', vfkJson);
    this.jsonSrc.OP = this.vfkParser.buildGeoJsonLayer('OP', vfkJson);
    this.prepareLayers();

    this.map.on('zoomend', () => {
      this.show();
    });

    this.show();
  }

  async show() {
    await this.removeHighlight(this.mapId);

    for (const layer of this.layersSrc) {
      if (this.groups.find(g => g.id === layer.group).enabled) {
        this.highlightFeature(this.mapId, layer, this.fitBounds);
        this.fitBounds = false;
      }
    }
  }

  highlightFeature(mapId, srcLayer, fitBoundsOptions: boolean) {
    const layerLeaflet = L.Proj.geoJson(srcLayer.data, {
      style: srcLayer.style,
      pointToLayer: srcLayer.pointToLayer,
      onEachFeature: (feature, layer) => {
        layer.on('click', (e) => {
          console.log('Klik na feature', feature);
        });
      }
    });

    this.layers[mapId].push(layerLeaflet);
    this.map.addLayer(layerLeaflet);

    if (fitBoundsOptions !== false) {
      this.map.fitBounds(layerLeaflet.getBounds(), fitBoundsOptions);
    }
  }

  async removeHighlight(mapId) {
    for (const l of this.layers[mapId]) {
      this.map.removeLayer(l);
    }

    this.layers[mapId] = [];
  }

  private loadVfkFile(): Promise<any> {
    const url = this.APP_BRAND.NAME === 'RSD'
      ? `documents/999/components/${this.config.gpVfkId}/content?t=${this.authService.getToken()}`
      : `attachments/${this.config.gpVfkId}/data?t=${this.authService.getToken()}`;

    return this.restangular.all(url)
      .withHttpConfig({ responseType: 'blob' })
      .customGET()
      .toPromise()
      .then((data) => {
        this.vfk = new Blob([data], {type: 'text/plain;charset=utf-8'});
      }, () => {

      });
  }

  private prepareLayers() {
    for (const layer of this.layersSrc) {
      const geojsonSrc = JSON.stringify(this.jsonSrc[layer.group]);
      const geojson = JSON.parse(geojsonSrc);

      geojson.features = geojson.features.filter(layer.filter);

      if (layer.customMapper) {
        geojson.features = layer.customMapper(geojson.features);
      }

      layer.data = geojson;
      this.canShowMap = true;
    }
  }

  private customMapperPonechane(features) {
    const actualFilter = (f) => {
      return f.geometry && (
        (f.properties.PRIZNAK_KONTEXTU === undefined && f.properties.STAV_DAT === 0)
        || (f.properties.PRIZNAK_KONTEXTU === 1 && f.properties.STAV_DAT === 0));
    };
    const futureFilter = (f) => {
      return f.geometry && (
        (f.properties.PRIZNAK_KONTEXTU === undefined && f.properties.STAV_DAT === 2)
        || (f.properties.PRIZNAK_KONTEXTU === 3 && f.properties.STAV_DAT === 1));
    };
    const actual = features.filter(actualFilter);
    const future = features.filter(futureFilter);

    const res = [];

    for (const ff of future) {
      for (const af of actual) {
        if (this.isSegmentOnSegment(af.geometry.coordinates, ff.geometry.coordinates)) {
          res.push(ff);
        }
      }
    }

    return res;
  }

  private customMapperNove(features) {
    const actualFilter = (f) => {
      return f.geometry && (
        (f.properties.PRIZNAK_KONTEXTU === undefined && f.properties.STAV_DAT === 0)
        || (f.properties.PRIZNAK_KONTEXTU === 1 && f.properties.STAV_DAT === 0));
    };
    const futureFilter = (f) => {
      return f.geometry && (
        (f.properties.PRIZNAK_KONTEXTU === undefined && f.properties.STAV_DAT === 2)
        || (f.properties.PRIZNAK_KONTEXTU === 3 && f.properties.STAV_DAT === 1));
    };
    const actual = features.filter(actualFilter);
    const future = features.filter(futureFilter);

    const res = [];
    for (const ff of future) {
      let match = false;
      for (const af of actual) {

        if (this.isSegmentOnSegment(af.geometry.coordinates, ff.geometry.coordinates)) {
          match = true;
        }

      }
      if (!match) {
        res.push(ff);
      }
    }

    return res;
  }

  private customMapperArrows(features) {
    const relations = [];
    for (const feature of features) {
      if (feature.properties.OPAR_TYPE === 'PC') {
        const connectedFeature = features.find(f => f.properties.OPAR_TYPE === 'PPC' && f.properties.PAR_ID === feature.properties.PAR_ID);

        if (connectedFeature) {
          relations.push({
            geometry: { type: 'LineString', coordinates: [feature.geometry.coordinates, connectedFeature.geometry.coordinates] },
            properties: { TEXT: connectedFeature.properties.TEXT },
            type: 'Feature'
          });
        }
      }
    }
    return relations;
  }

  private pointToLayerOP(feature, latlng) {
    if (this.map.getZoom() < 12) {
      return;
    }

    const style = [];

    const zoomFontSizeMatrix = {
      11: 4.1,
      12: 5.3,
      13: 6.5,
      14: 10.5,
      15: 20.5,
    };

    // [hor, vert]
    const vztaznyBodMatrix = {
      1: [0, 1],
      2: [0.5, 1],
      3: [1, 1],
      4: [0, 0],
      5: [0.5, 0],
      6: [1, 0],
      7: [0, 0.5],
      8: [0.5, 0.5],
      9: [1, 0.5],
    };

    const fontSizeCoefficient = zoomFontSizeMatrix[this.map.getZoom()];
    const fontSize = feature.properties.VELIKOST * fontSizeCoefficient;
    const size = this.computeTextSize(feature.properties.TEXT, fontSize);
    const vztaznyBod = feature.properties.VZTAZNY_BOD;

    if (feature.properties.UHEL) {
      const uhel = (feature.properties.UHEL % 360) - (feature.properties.UHEL > 0 ? 4 : 0);
      style.push('transform-origin: ' + vztaznyBodMatrix[vztaznyBod][0] * 100 + '% ' + vztaznyBodMatrix[vztaznyBod][1] * 100 + '% ');
      style.push('transform: rotate(' + -1 * uhel + 'deg)');
    }

    style.push('font-size: ' + fontSize + 'px');
    style.push('line-height: ' + fontSize + 'px');
    style.push('color: #FF0000');

    const labelDiv = L.divIcon({
      className: 'gp-vfk-op',
      html: `
        <div class="gp-vfk-op-bg" style="${style.join(';')}"></div>
        <div class="gp-vfk-op-number" style="${style.join(';')}">${feature.properties.TEXT}</div>
      `,
      iconAnchor: [
        size.width * vztaznyBodMatrix[vztaznyBod][0],
        size.height * vztaznyBodMatrix[vztaznyBod][1]
      ],
      iconSize: [size.width, size.height]
    });
    return L.marker(latlng, {icon: labelDiv});
  }

  private pointToLayerDefault(feature, latlng) {
    return L.circleMarker(latlng, { radius: 8, fillOpacity: 0, color: '#ff00ff', weight: 2 });
  }

  private computeTextSize(text, fontSize) {
    text = text + '';
    let widthFactor = 0;

    for (const ch of text) {
      if (/[0-9]/.test(ch)) {
        widthFactor += 0.63;
      } else if (ch === '/') {
        widthFactor += 0.35;
      } else {
        widthFactor += 0.65;
      }
    }

    return {
      width: widthFactor * fontSize,
      height: fontSize
    };
  }

  /**
   * Vraci true, pokud cela primka 2 lezi na primce 1
   */
  isSegmentOnSegment(line1, line2, tolerance = 0.2) {

    const [a1, b1] = line1;
    const [a2, b2] = line2;

    const ABx = b1[0] - a1[0];
    const ABy = b1[1] - a1[1];

    const lengthAB = Math.hypot(ABx, ABy);
    if (lengthAB === 0) {
      return false;
    }

    const lengthSqAB = ABx * ABx + ABy * ABy;

    function pointOnSegment(p) {

      // vektor A1 -> P
      const APx = p[0] - a1[0];
      const APy = p[1] - a1[1];

      // vzdalenost bodu od primky
      const cross = Math.abs(ABx * (a1[1] - p[1]) - (a1[0] - p[0]) * ABy);

      const distance = cross / lengthAB;

      if (distance > tolerance) {
        return false;
      }

      // projekce musi lezet mezi A1 a B1
      const dot = APx * ABx + APy * ABy;

      if (dot < -tolerance) {
        return false;
      }

      if (dot > lengthSqAB + tolerance) {
        return false;
      }

      return true;
    }

    return pointOnSegment(a2) && pointOnSegment(b2);
  }
}
